import { renderPrincipal } from "@/shared/components/ResourceView";
import { RobotoLinkHoverUnderline } from "@/shared/components/RobotoLinkHoverUnderline";
import {
  cellStyles,
  createColumnHelper,
  renderDashOr,
  type ICellRendererParams,
} from "@/shared/foundation/primitives/Table";
import { TagGroup } from "@/shared/foundation/primitives/Tag";
import { Goto } from "@/shared/navigation/Goto";

import { type Device } from "./Device";

const columnHelper = createColumnHelper<Device>();

export const devicesTableColumns = [
  columnHelper.accessor("device_id", {
    headerName: "Device ID",
    // Primary column for devices (no Name field) — treated like Name: flex 3.
    flex: 3,
    minWidth: 200,
    sortable: true,
    cellRenderer: (p: ICellRendererParams<Device, string>) => {
      const id = p.value;
      if (!id) {
        return null;
      }
      return (
        <RobotoLinkHoverUnderline
          to={`${Goto.route.Devices}/${encodeURIComponent(id)}`}
          className={cellStyles.primaryContent}
        >
          {id}
        </RobotoLinkHoverUnderline>
      );
    },
  }),
  columnHelper.accessor("created_by", {
    headerName: "Created By",
    minWidth: 150,
    sortable: true,
    cellRenderer: renderPrincipal,
  }),
  columnHelper.timestamp("created", {
    headerName: "Created",
    minWidth: 150,
    sortable: true,
    variant: "relative",
  }),
  columnHelper.accessor("tags", {
    headerName: "Tags",
    flex: 3,
    minWidth: 180,
    cellClass: cellStyles.tagsCell,
    valueFormatter: (p) => (p.value ?? []).join(", "),
    cellRenderer: renderDashOr((p: ICellRendererParams<Device, string[]>) => (
      <TagGroup tags={p.value ?? []} maxDisplayCount={3} />
    )),
  }),
  columnHelper.timestamp("modified", {
    headerName: "Modified",
    minWidth: 150,
    sortable: true,
    variant: "relative",
  }),
  columnHelper.accessor("modified_by", {
    headerName: "Modified By",
    minWidth: 150,
    sortable: true,
    cellRenderer: renderPrincipal,
  }),
];
